var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "zxs-banner",
      class: { "preview-mode": _vm.pageType === 1 },
    },
    [
      _vm.swipeShow
        ? _c(
            "div",
            {
              ref: "swipecon",
              staticClass: "swiper-con",
              attrs: { id: "swiper-con" },
              on: {
                click: function ($event) {
                  return _vm.onlyOneData(_vm.resource)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.resource, function (resource, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "swiper-slide items",
                      style: {
                        backgroundImage: "url(" + resource.content + ")",
                      },
                    },
                    [
                      _vm.aosTag[index] === 301
                        ? _c("div", { staticClass: "ad-text" }, [
                            _vm._v("广告"),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }